export enum QuotaRulesEnum {
  StorageLocationQuota = "StorageLocationQuota",
  StorageKindQuota = "StorageKindQuota",
  DeliveryThroughputQuota = "DeliveryThroughputQuota",
  ShareScreeningQuota = "ShareScreeningQuota",
  AssetObjectTreeStorageSizeQuota = "AssetObjectTreeStorageSizeQuota",
}
